<template>
	<div class="step4">
		<div class="content">
			<img class="icon" alt="Completed" :src="`images/step3-focus.svg`"/>
			<label class="title">CONGRATULATIONS!</label>
			<label class="subtitle">Your appointment has been confirmed.</label>
			<label class="message">To cancel your appointment call the {{ clinic.name }} office.</label>
			<label class="message">Please cancel no less than 24 hours prior to your appointment time.</label>
		</div>
		<div class="footer-actions mt-4">
			<button class="btn-beltone xl" @click="returnToHomepage()">Return To Homepage</button>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Services from '../../mixins/services';

export default {
	mixins: [Services],
	computed: mapState({
		clinic: state => state.OnlineScheduling.clinic,
		globals: state => state.OnlineScheduling.globals,
		clientToken: state => state.ClientToken.clientToken,
	}),
	methods: {
		returnToHomepage() {
            window.top.location.href = `${document.referrer}${this.globals.returnToHomepage}`;
		}
	}
}
</script>
